'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function buildUrl(url, query) {
  if (!query) return url;

  var querys = [];
  Object.keys(query).forEach(function (key) {
    if (query[key] === undefined) return;
    querys.push(key + '=' + encodeURIComponent(JSON.stringify(query[key])));
  });

  return url + '?' + querys.join('&');
}
var REQUEST_SETTING = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};
function buildInit(method, body) {
  return _extends({
    method: method,
    body: body
  }, REQUEST_SETTING);
}

function rejectFailRequest(response) {
  return response.ok ? response : Promise.reject(response);
}
function getResponseContent(response) {
  if (response.status === 204) return null;

  return response.json();
}

var get = function get(_ref) {
  var url = _ref.url,
      query = _ref.query;
  return fetch(buildUrl(url, query), buildInit('GET')).then(rejectFailRequest).then(getResponseContent);
};
var post = function post(_ref2) {
  var url = _ref2.url,
      data = _ref2.data;
  return fetch(url, buildInit('POST', JSON.stringify(data))).then(rejectFailRequest).then(getResponseContent);
};
var put = function put(_ref3) {
  var url = _ref3.url,
      data = _ref3.data;
  return fetch(url, buildInit('PUT', JSON.stringify(data))).then(rejectFailRequest).then(getResponseContent);
};
var patch = function patch(_ref4) {
  var url = _ref4.url,
      data = _ref4.data;
  return fetch(url, buildInit('PATCH', JSON.stringify(data))).then(rejectFailRequest).then(getResponseContent);
};
var del = function del(_ref5) {
  var url = _ref5.url;
  return fetch(url, buildInit('DELETE')).then(rejectFailRequest).then(getResponseContent);
};

exports.get = get;
exports.post = post;
exports.put = put;
exports.patch = patch;
exports.del = del;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/codev-api/methods.js
// module id = 1077
// module chunks = 0